module.exports = __webpack_public_path__ + "static/media/spain_icon.34a0dd04.png";